import { galleryImages } from "./gallery";
import { categories, projects } from "./projects";
import { resources } from "./resources";
import { siteContent } from "./siteContent";

export function getPublicProjects() {
  return projects
    .filter((project) => project.visibility === "public" && project.reviewState === "approved")
    .sort((a, b) => Number(b.pinned) - Number(a.pinned) || a.sortOrder - b.sortOrder);
}

export function getPublicCategories() {
  return categories;
}

export function getPublicSiteContent() {
  return siteContent;
}

export function getPublicResources() {
  return resources
    .filter((resource) => resource.visibility === "public" && resource.reviewState === "approved")
    .sort((a, b) => Number(b.featured) - Number(a.featured) || a.sortOrder - b.sortOrder);
}

export function getPublicGalleryImages() {
  return galleryImages
    .filter((image) => image.visibility === "public" && image.reviewState === "approved")
    .sort((a, b) => a.sortOrder - b.sortOrder);
}
